import React from 'react';
import './main.scss'
import { animateUp } from '../../settings/Animation'
import { Link } from 'react-router-dom';

const Main = () => {
  return (
    <div className='content home-page'>
      <h3 {...animateUp} data-aos-duration="600">Здравствуйте, Я</h3>
      <h1 {...animateUp} data-aos-duration="800">Ибрагимов Рустам</h1>
      <p {...animateUp} data-aos-duration="1000">
        Рад вас видеть на моём веб сайте.В этом сайте находиться все мои проекты и моё резюме.Вы можете ближе познакомиться
        с ними.
        Желаю хорошего просмотра:)
      </p>
      <Link className='btn-link' to='/portfolio' {...animateUp} data-aos-duration="1400" >Портфолио</Link>
    </div>
  )
}
export default Main